import { useEffect } from "react";
import { toast } from "sonner";

// Deters copying of text/images from the site. Inputs stay usable.
export function CopyGuard() {
  useEffect(() => {
    const inField = (el) => el && el.closest && el.closest("input, textarea, [contenteditable='true']");
    let last = 0;
    const notify = () => {
      const now = Date.now();
      if (now - last < 1500) return;
      last = now;
      toast.error("Copying content from KRV Prime is not allowed.");
    };
    const onCopy = (e) => { if (inField(e.target)) return; e.preventDefault(); notify(); };
    const onContext = (e) => { if (inField(e.target)) return; e.preventDefault(); notify(); };
    const onDrag = (e) => { if (e.target && e.target.tagName === "IMG") e.preventDefault(); };
    document.addEventListener("copy", onCopy);
    document.addEventListener("cut", onCopy);
    document.addEventListener("contextmenu", onContext);
    document.addEventListener("dragstart", onDrag);
    return () => {
      document.removeEventListener("copy", onCopy);
      document.removeEventListener("cut", onCopy);
      document.removeEventListener("contextmenu", onContext);
      document.removeEventListener("dragstart", onDrag);
    };
  }, []);
  return null;
}
